import React from 'react';
const SvgVssxThumbnail = React.forwardRef((rest, ref) => {
  const props = { ...rest, ref };
  return (
    <svg viewBox="0 0 96 96" width="1em" height="1em" {...props}>
      <linearGradient
        id="vssx-thumbnail_svg__a"
        gradientUnits="userSpaceOnUse"
        x1={22.097}
        y1={7.596}
        x2={89.903}
        y2={88.403}
      >
        <stop offset={0} stopColor="#fff" stopOpacity={0} />
        <stop offset={0.226} stopColor="#fcfcfc" stopOpacity={0.023} />
        <stop offset={0.363} stopColor="#f4f4f4" stopOpacity={0.036} />
        <stop offset={0.475} stopColor="#e6e6e6" stopOpacity={0.048} />
        <stop offset={0.574} stopColor="#d1d1d1" stopOpacity={0.057} />
        <stop offset={0.665} stopColor="#b7b7b7" stopOpacity={0.067} />
        <stop offset={0.75} stopColor="#979797" stopOpacity={0.075} />
        <stop offset={0.83} stopColor="#707070" stopOpacity={0.083} />
        <stop offset={0.906} stopColor="#444" stopOpacity={0.091} />
        <stop offset={0.976} stopColor="#121212" stopOpacity={0.098} />
        <stop offset={1} stopOpacity={0.1} />
      </linearGradient>
      <path fill="url(#vssx-thumbnail_svg__a)" d="M88 6H24v84h64V6z" />
      <path fill="#FFF" d="M26 8h60v80H26z" />
      <g fill="#C8C8C8">
        <path d="M32 14v32h22V14H32zm20 2v28H34V16h18zM32 50v32h22V50H32zm20 2v28H34V52h18zM60.444 14H58v32h22V14H60.444zM78 44H60V16h18v28zM58 50v32h22V50H58zm20 2v28H60V52h18z" />
      </g>
      <path fill="#949494" d="M24 6v84h64V6H24zm62 82H26V8h60v80z" />
      <path fill="#3955A3" d="M8 34l40-6v52L8 74z" />
      <path
        fill="#FFF"
        d="M38 42l-7.33 24h-5.43L18 42h5.163L27.6 58.703c.238.904.381 1.702.43 2.393h.09c.069-.747.222-1.567.46-2.46L32.985 42H38z"
      />
      <linearGradient
        id="vssx-thumbnail_svg__b"
        gradientUnits="userSpaceOnUse"
        x1={67.34}
        y1={19.66}
        x2={84.46}
        y2={2.54}
      >
        <stop offset={0} stopColor="#fff" stopOpacity={0} />
        <stop offset={0.854} stopColor="#fff" stopOpacity={0.213} />
        <stop offset={1} stopColor="#fff" stopOpacity={0.25} />
      </linearGradient>
      <path fill="url(#vssx-thumbnail_svg__b)" d="M24 6v2h62v48h2V6z" />
      <linearGradient
        id="vssx-thumbnail_svg__c"
        gradientUnits="userSpaceOnUse"
        x1={35.433}
        y1={87.54}
        x2={36.456}
        y2={77.902}
      >
        <stop offset={0} stopColor="#828282" stopOpacity={0} />
        <stop offset={0.17} stopColor="#7e7e7e" stopOpacity={0.034} />
        <stop offset={0.346} stopColor="#717171" stopOpacity={0.069} />
        <stop offset={0.525} stopColor="#5d5d5d" stopOpacity={0.105} />
        <stop offset={0.706} stopColor="#404040" stopOpacity={0.141} />
        <stop offset={0.886} stopColor="#1b1b1b" stopOpacity={0.178} />
        <stop offset={0.997} stopOpacity={0.2} />
      </linearGradient>
      <path fill="url(#vssx-thumbnail_svg__c)" d="M48 88H24V76.4L48 80z" />
      <linearGradient id="vssx-thumbnail_svg__d" gradientUnits="userSpaceOnUse" x1={28} y1={78.375} x2={28} y2={29.517}>
        <stop offset={0} stopColor="#fff" stopOpacity={0} />
        <stop offset={0.859} stopColor="#fff" stopOpacity={0.155} />
        <stop offset={1} stopColor="#fff" stopOpacity={0.18} />
      </linearGradient>
      <path fill="url(#vssx-thumbnail_svg__d)" d="M48 28L8 34v40l40 6z" />
    </svg>
  );
});
export default SvgVssxThumbnail;
SvgVssxThumbnail.iconName = 'vssx-thumbnail';
SvgVssxThumbnail.displayName = 'SvgVssxThumbnail';
